import { Label, Switch } from "@libs/zapi-ui/shadcn";
import { useMeStore } from "@/zapi-frontend/shared/hooks/useMe";
import { toast } from "sonner";
import { Typography } from "@libs/zapi-ui/custom";
import { updateFeaturePermission } from "./updateFeaturePermission";
import { useProjectSidebarStore } from "@/zapi-frontend/stores/projectSidebarStore";

type TSmallModeSwitchProps = { id?: string; className?: string };

export function SmallModeSwitch(props: TSmallModeSwitchProps) {
  const { id = "labs-mode", className = "" } = props;
  const { isLabs, setMe } = useMeStore();
  const { closeHandler, isLabsTabOpen } = useProjectSidebarStore();

  const handleChange = async (checked: boolean) => {
    setMe({ isLabs: checked });

    if (!checked && isLabsTabOpen()) {
      closeHandler();
    }

    try {
      await updateFeaturePermission(checked ? 1 : 0);
    } catch (error) {
      console.error(error);
      toast.error(`Failed to ${checked ? "enable" : "disable"} labs mode`);
      setMe({ isLabs: !checked });
    }
  };

  return (
    <div data-testid="labs-mode-container" className={`flex flex-col ${className}`}>
      <div className="flex items-center justify-between mb-2">
        <Label htmlFor={id}>
          <Typography variant="label2">Labs Mode</Typography>
        </Label>

        <Switch id={id} data-testid="labs-mode-switch" checked={!!isLabs} onCheckedChange={handleChange} />
      </div>
      <Typography variant="body3" color="zinc600">
        Labs Mode gives you access to experimental features that are currently being tested
      </Typography>
    </div>
  );
}
